import { keepCoordinates } from '@foundryspatial/mixin-map-coordinator';
import Vue from 'vue';
import Router from 'vue-router';

import Home from '@/views/Home.vue';
import Watershed from '@/views/Watershed.vue';

Vue.use(Router);

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
            meta: {
                showMainNav: true,
            },
        },
        {
            path: '/watershed',
            name: 'watershed',
            component: Watershed,
            meta: {
                showMainNav: true,
            },
        },
        {
            path: '/watershed/static-report',
            name: 'static-report',
            component: () => import(/* webpackChunkName: "static-report" */ '@/views/StaticReport.vue'),
            meta: {
                showMainNav: false,
            },
        },
        {
            path: '/equivalent-clearcut-area/:coordinates?',
            name: 'equivalent-clearcut-area',
            component: () => import(/* webpackChunkName: "equivalent-clearcut-area" */ '@/views/EquivalentClearcutArea.vue'),
            meta: {
                showMainNav: true,
            },
            beforeEnter: keepCoordinates,
        },
    ],
});
